var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Country/denmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Country/denmark",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.167000, 0.000000)",
    fill: "#D80027",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M507.666,222.609 C491.303,97.002 383.9,0 253.833,0 C234.718,0 216.101,2.113 198.181,6.085 L198.181,222.609 L507.666,222.609 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.398,222.609 L131.398,31.127 C61.105,69.481 10.783,139.832 0,222.609 L131.398,222.609 L131.398,222.609 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.398,289.391 L0,289.391 C10.783,372.168 61.105,442.519 131.398,480.872 L131.398,289.391 L131.398,289.391 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.181,289.391 L198.181,505.915 C216.101,509.887 234.718,512 253.833,512 C383.9,512 491.303,414.998 507.666,289.391 L198.181,289.391 L198.181,289.391 Z",
    id: "Path"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDk);
export default __webpack_public_path__ + "static/media/DK.746aeb75345600ad51bd8e6687579356.svg";
export { ForwardRef as ReactComponent };